import styled from "styled-components";

import { TOOLTIPS } from "../../utils/tooltipConstants";
import deleteImg from "./../../images/icon_delete.svg";
import { BaseButton, TooltipBox } from "./BaseButton";

const IconButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.colors.accentRed};
  & :hover > ${TooltipBox} {
    background-color: ${({ theme }) => theme.colors.accentRed};
  }
  :disabled,
  [disabled] {
    background-color: #c6c8ce;
    cursor: not-allowed;
  }
`;

export function DeleteButton(props: any) {
  const { tooltipText, onClick } = props;
  const tooltipContent = tooltipText ? tooltipText : TOOLTIPS.delete.text;
  return (
    <IconButton onClick={onClick} tooltip={tooltipContent} {...props}>
      <img src={deleteImg} alt={tooltipContent} />
    </IconButton>
  );
}
